import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "@arco-design/web-react/es/Trigger/style";
import Trigger from "@arco-design/web-react/es/Trigger";
import { IconLucideMessageSquare } from '@wegic/icon';
import { ScrollArea } from '@wegic/ui';
import '@wegic/ui/dist/components/ScrollArea/index.css';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import sidebarStyles from '../index.module.less';
import RecentProjectList from '../RecentProjectList';
import styles from './index.module.less';
function CollapsedChatHistory(props) {
    const { activeProjectId, isAnyProjectRenaming, onDeleteClick, onRenameCancel, onRenameSave, onRenameStart, recentProjects, renamingProjectId } = props;
    const [popupVisible, setPopupVisible] = useState(false);
    const [closeAfterRenaming, setCloseAfterRenaming] = useState(false);
    useEffect(()=>{
        if (isAnyProjectRenaming) {
            setPopupVisible(true);
            return;
        }
        if (closeAfterRenaming) {
            setPopupVisible(false);
            setCloseAfterRenaming(false);
        }
    }, [
        closeAfterRenaming,
        isAnyProjectRenaming
    ]);
    const handleVisibleChange = (visible)=>{
        if (!isAnyProjectRenaming) {
            setPopupVisible(visible);
            setCloseAfterRenaming(false);
            return;
        }
        if (visible) {
            setPopupVisible(true);
            setCloseAfterRenaming(false);
            return;
        }
        setPopupVisible(true);
        setCloseAfterRenaming(true);
    };
    const chatHistoryContent = /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.panel, {
            [styles['panel-renaming']]: isAnyProjectRenaming
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.title,
                children: intl.get('workspace.sidebar.recents')
            }),
            /*#__PURE__*/ _jsxs(ScrollArea, {
                className: styles['scroll-area'],
                scrollShadow: "bottom",
                children: [
                    /*#__PURE__*/ _jsx(RecentProjectList, {
                        activeProjectId: activeProjectId,
                        className: classNames(styles.list, {
                            [styles['list-renaming']]: isAnyProjectRenaming
                        }),
                        isAnyProjectRenaming: isAnyProjectRenaming,
                        recentProjects: recentProjects,
                        renamingProjectId: renamingProjectId,
                        onDeleteClick: onDeleteClick,
                        onRenameCancel: onRenameCancel,
                        onRenameSave: onRenameSave,
                        onRenameStart: onRenameStart,
                        variant: "collapsed-panel"
                    }),
                    recentProjects.length === 0 && /*#__PURE__*/ _jsx("div", {
                        className: classNames(sidebarStyles['empty-recent'], styles['empty-recent']),
                        children: intl.get('workspace.sidebar.emptyRecentProjects')
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsx(Trigger, {
        trigger: "hover",
        position: "right",
        popupAlign: {
            right: 8
        },
        popupVisible: popupVisible,
        onVisibleChange: handleVisibleChange,
        popup: ()=>chatHistoryContent,
        updateOnScroll: true,
        children: /*#__PURE__*/ _jsx("button", {
            className: classNames(sidebarStyles['icon-button'], styles.button),
            type: "button",
            "aria-label": intl.get('workspace.sidebar.recents'),
            children: /*#__PURE__*/ _jsx(IconLucideMessageSquare, {
                className: sidebarStyles.icon,
                fontSize: 16
            })
        })
    });
}
export default CollapsedChatHistory;
